import { useMemo, useEffect } from 'react';
export var useAppendedElement = function () {
    var element = useMemo(function () { return document.createElement('div'); }, []);
    useEffect(function () {
        document.body.appendChild(element);
        return function () {
            document.body.removeChild(element);
        };
    }, [element]);
    return element;
};
//# sourceMappingURL=useAppendElement.js.map